import InputNumber from './src/input-number';

module.exports = InputNumber;


// WEBPACK FOOTER //
// ./src/components/input-number/index.js